import { TextView } from "@components";
import React, { useEffect, useState } from "react";
import ContentEditable from "react-contenteditable";
import { useNavigate } from "react-router-dom";
import { colors } from "../../utils";
import * as Styled from "./styles";
import { transformEditorText } from "../../utils/helpers";
import WheelComponent from "../WheelComponent";

export default function WheelItem({
  item,
  setModalOpen = null,
  setOnLeave = null,
  wheelInformation = null,
  prevIndexRef = null,
  setShowResults = null,
  handleNavigate = null,
}) {
  const [chartState, setChartState] = useState([]);
  const { wheel_image, wheel_name, user_profile, id, wheel_segments, version } =
    item;
  const { first_name, last_name } = user_profile;

  const nav = useNavigate();

  useEffect(() => {
    const wheelUpdatedData = wheel_segments?.map((obj, index) => ({
      label: "blank",
      value: "1",
      isBlank: false,
      ...obj,
    }));

    const wheelUpdatedDataSorted = wheelUpdatedData?.sort(
      (a, b) => a.position - b.position
    );

    setChartState(wheelUpdatedDataSorted);
  }, [item]);

  const onClick = () => {
    setShowResults(false);

    // Call handleNavigate if it exists
    if (handleNavigate) {
      handleNavigate();
      return;
    }

    if (setOnLeave && setModalOpen) {
      const currentIndex = wheelInformation?.currentIndex;

      if (prevIndexRef.current !== currentIndex) {
        setOnLeave(() => () => {
          if (version == 2) {
            nav(`/wheel/${id}`);
          } else {
            nav(`/wheelView/${id}`);
          }
        });
        setModalOpen(true);
        prevIndexRef.current = currentIndex;
      } else {
        if (version == 2) {
          nav(`/wheel/${id}`);
        } else {
          nav(`/wheelView/${id}`);
        }
      }
    } else {
      if (version == 2) {
        nav(`/wheel/${id}`);
      } else {
        nav(`/wheelView/${id}`);
      }
    }
  };

  const itemVariants = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    hover: {
      scale: 1.02,
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      transition: {
        duration: 0.2,
        ease: "easeInOut",
      },
    },
    tap: {
      scale: 0.98,
      transition: {
        duration: 0.1,
      },
    },
  };

  return (
    <Styled.SearchItem
      onClick={onClick}
      variants={itemVariants}
      initial="initial"
      animate="animate"
      whileHover="hover"
      whileTap="tap"
    >
      <div style={{ minWidth: 50 }}>
        <WheelComponent
          config={{
            isSmallView: true,
            showTooltips: false,
          }}
          userData={{
            id: Math.random(),
            url: wheel_image,
          }}
          maxSelectedArcs={0}
          arcThickness={-2}
          chartData={chartState}
          margin={1}
          containerDivStyle={{
            width: "100%",
            height: "100%",
            maxWidth: "60px",
            maxHeight: "60px",
          }}
        />
      </div>

      <div style={{ marginLeft: 10, flexGrow: 1 }}>
        <TextView variant="subtitle" style={{ fontSize: 14 }}>
          <ContentEditable html={transformEditorText(wheel_name)} disabled />
        </TextView>
        <TextView color={colors.lightGrey}>
          By {first_name} {last_name}
        </TextView>
      </div>
    </Styled.SearchItem>
  );
}
